import { useTranslation } from "react-i18next";
import PlatformCards, { IPurePlatformCard } from "../PlatformCards";
import TitleWithTooltip from "src/common/components/TitleWithTooltip/TitleWithTooltip";

export const PlatformsSelectedForPublication = ({
  selectedPlatforms,
}: {
  selectedPlatforms: string[];
}) => {
  const { t } = useTranslation();

  const selectedCards = PlatformCards.filter((pc: IPurePlatformCard) =>
    selectedPlatforms.includes(pc.id),
  ).map((pc: IPurePlatformCard) => ({
    ...pc,
    component: <div className="relative w-full">{pc.component}</div>,
  }));

  const needsContact = selectedCards.some(
    (e) =>
      e.id === "iPhone" ||
      e.id === "iPad" ||
      e.id === "MacOS" ||
      e.id === "WebGLiframe" ||
      e.id === "WebGLApp" ||
      e.id === "WebGLApp_scorm",
  );

  return (
    <div className="flex flex-col grow w-full h-full justify-between">
      <div className="flex flex-col items-center gap-1 h-full">
        <TitleWithTooltip
          title={t("pages.projectGroup.publish.confirmationBeforePublish.selectedPlatforms")}
          tooltip={t("tooltip.platformsForPublicationExplanation")}
          className="font-semibold"
        />

        <div className="h-full w-full flex flex-row flex-wrap items-center justify-center">
          {selectedCards.map((card, i) => (
            <div
              key={`${card.id}-${i}`}
              className="flex flex-col items-center justify-center p-2 m-1 w-32 h-20 border-2 select-none rounded-md w-1/10 border-green-500"
            >
              {card.component}
            </div>
          ))}
        </div>

        <div className={`text-yellow-500 m-2 flex items-center ${needsContact ? "" : "invisible"}`}>
          <h3 className="text-sm text-center">
            ⚠️ {t("pages.projectGroup.publish.contactNeededWarning")}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default PlatformsSelectedForPublication;
